<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
    <li class="breadcrumb-item"><router-link to="/solutions/digitalinfrastructure">Digital Infrastructure</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">Networking</li>
  </ol>
</nav>

<div class="row">

<div class="col-lg-8">
<h2 class="title">Networking</h2>

                            <h3 class="title  pt-2"></h3>
                <p class="lead">
                  Networking is at the center of business innovation. Users aim
                  for fast, reliable and secure network infrastructure to build,
                  create and grow. We utilize the networking best approaches
                  with innovation to build the best solution for our clients.
                </p>
                <p class="lead">
                  Our professionals and expertise create, design and deploy
                  secure custom-built networking models for Businesses with
                  increasing productivity and are cost-effective. Protect your
                  data, enable growth and leverage on your network resources
                  securely and efficiently with a high-speed network as many
                  businesses find it difficult to configure all the features and
                  functionality inherent in these technologies. However, we
                  offer network solutions like;
                </p>
                <ul class="lead">
                  <li>
                    SDWAN – Cost-effective with increased connectivity using a
                    virtual WAN Architecture. Leverage SDWAN for your enterprise
                    networks.
                  </li>
                  <li>
                    Data Center Networking - We create, design, and implement
                    optimized data center networking solution that makes
                    connectivity enjoyable.
                  </li>
                  <li>
                    Campus LAN Network- Enjoy a fast, reliable and resilient LAN
                    vital for collaboration, ensuring high-level productivity
                    for users.
                  </li>
                  <li>
                    Wireless Networks- Our wireless network meets the needs of
                    all users, giving them complete freedom and flexibility in
                    the way they interact with your networks.
                  </li>
                  <li>
                    Network virtualization and security- We help our clients
                    adopt a software-defined approach to network management and
                    security to gain visibility and control as it speeds up
                    provisioning.
                  </li>
                </ul>
                <p class="lead"></p>

</div>

<div class="col-lg-4">
  <DigitalInfraSideNav></DigitalInfraSideNav>
</div>
</div>
        

        </div>
      </section>
    </div>
  </div>
</template>
<script>
import DigitalInfraSideNav from "./DigitalInfraSideNav";
export default {
  name: "overview",
  components : {
    DigitalInfraSideNav
  }
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
